import React from 'react';

import { Box, Button, Icon } from '@opendoor/bricks/core';
import { A11yProps } from '@opendoor/bricks/system/a11y.types';

type FavoriteButtonProps = {
  isFavorite?: boolean;
  onFavoriteClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  isFavoriteResponsePending?: boolean;
} & A11yProps<'button'>;

/**
 * Favorite button for PropertyCard
 *
 * storybook-check-ignore
 */
export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  isFavorite = false,
  onFavoriteClick,
  isFavoriteResponsePending = false,
  ...props
}) => {
  const IconName = isFavorite ? 'favorite-filled' : 'favorite';
  const Color = isFavorite ? 'terracotta50' : 'neutrals100';
  return (
    <Box position="absolute" top={3} right={3}>
      <Button
        variant="icon"
        onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => onFavoriteClick(e)}
        disabled={isFavoriteResponsePending}
        data-testid={`favorite-icon-${IconName}`}
        analyticsName="cake-property-card-favorite-button"
        {...props}
      >
        <Icon name={IconName} color={Color} size={16} />
      </Button>
    </Box>
  );
};
